const readMoreContentTop = () => {
  const content = $('#read-more-mobile .right-description');
  const originalHTML = content.html();
  const maxLength = 0;
  const toggleText = `read all <span>+</span>`;
  const readMoreButton = $(`<p id="readMore">${toggleText}</p>`);

  function checkMobile() {
    return window.innerWidth <= 1024;
  }
  function toggleReadMore() {
    if (checkMobile()) {
      if (content.text().length > maxLength) {
        const trimmedHTML = content.html().substr(0, maxLength);
        content.html(trimmedHTML);

        if ($('#readMore').length === 0) {
          readMoreButton.insertAfter(content);
        }

        $('#readMore').on('click', function () {
          if (content.html() === trimmedHTML) {
            content.html(originalHTML);
            $('#readMore').remove(); // Remove the readmore
          } else {
            content.html(trimmedHTML);
            $('#readMore').html(toggleText);
          }
        });

        // initial section has display: none
        $('#read-more-mobile').css('display', 'block');
      } else {
        $('#readMore').remove();
      }
    } else {
      $('#readMore').remove(); // Remove the readmore if > 1024px
      content.html(originalHTML);
    }
  }

  toggleReadMore();

  $(window).resize(function () {
    toggleReadMore();
  });
};

export default readMoreContentTop;
